// extracted by mini-css-extract-plugin
export default {"wrapper":"PatientSelectionDialog_wrapper__GkurL","patientSelectBtn":"PatientSelectionDialog_patientSelectBtn__vMSQb","buttons":"PatientSelectionDialog_buttons__CUGsg"};